const TermsConditions = ({ onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 w-full h-full backdrop-blur-md p-4">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-xl shadow-lg w-full max-w-2xl relative animate-fadeIn">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 dark:hover:text-gray-200 transition-all text-lg font-bold"
        >
          ✖
        </button>

        {/* Title */}
        <h3 className="text-2xl font-bold text-gray-900 dark:text-white text-center mb-4">
           Terms & Conditions
        </h3>

        {/* Scrollable Content */}
        <div className="text-gray-700 dark:text-gray-300 text-sm max-h-60 overflow-y-auto p-3 border rounded-md bg-gray-100 dark:bg-gray-800">
          <p className="mb-2">
            For the purpose of these Terms and Conditions, The term "we", "us", "our" used anywhere
            on this page shall mean **SHIKHA JAIN**, whose registered/operational office is **B71,
            Ground Floor, Right Side, Faridabad, Haryana 121003**. "you", “your”, "user", “visitor”
            shall mean any natural or legal person who is visiting our website and/or agreed to
            purchase from us.
          </p>

          <h4 className="font-semibold mt-3">1. Website Use & Changes</h4>
          <p>
            - The content of the pages of this website is subject to change without notice.
            <br />- We do not guarantee the accuracy, timeliness, completeness, or suitability of
            any information on our website.
          </p>

          <h4 className="font-semibold mt-3">2. Liability & Warranty</h4>
          <p>
            - Neither we nor any third parties provide any warranty or guarantee as to the accuracy,
            performance, completeness, or suitability of the information and materials found on this
            website for any particular purpose.
            <br />- You acknowledge that such information may contain inaccuracies or errors, and we
            expressly exclude liability for any such inaccuracies or errors to the fullest extent
            permitted by law.
          </p>

          <h4 className="font-semibold mt-3">3. User Responsibilities</h4>
          <p>
            - Your use of any information or materials on our website and/or product pages is
            entirely at your own risk, for which we shall not be liable.
            <br />- It shall be your responsibility to ensure that any products, services, or
            information available through our website meet your specific requirements.
          </p>

          <h4 className="font-semibold mt-3">4. Copyright & Trademarks</h4>
          <p>
            - Our website contains material which is owned by or licensed to us.
            <br />- Reproduction is prohibited other than in accordance with the copyright notice.
            <br />- All trademarks reproduced in our website that are not the property of, or
            licensed to, the operator are acknowledged on the website.
          </p>

          <h4 className="font-semibold mt-3">5. Unauthorized Use</h4>
          <p>
            - Unauthorized use of information provided by us shall give rise to a claim for damages
            and/or be a criminal offense.
          </p>

          <h4 className="font-semibold mt-3">6. External Links</h4>
          <p>
            - From time to time, our website may include links to other websites. These links are
            provided for your convenience to provide further information.
            <br />- You may not create a link to our website from another website or document
            without prior written consent.
          </p>

          <h4 className="font-semibold mt-3">7. Governing Law</h4>
          <p>
            - Any dispute arising out of use of our website and/or purchase with us and/or any
            engagement with us is subject to the laws of India.
            <br />- We shall be under no liability whatsoever in respect of any loss or damage
            arising directly or indirectly out of the decline of authorization for any transaction
            on account of the cardholder having exceeded the preset limit mutually agreed by us with
            our acquiring bank from time to time.
          </p>
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          className="mt-5 bg-red-500 text-white px-4 py-2 rounded-md w-full hover:bg-red-600 transition-all"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default TermsConditions;
